import CharacterManagePane from './CharacterManagePane';

export default CharacterManagePane;
export { CharacterManagePane };
